/** OL Feature 속성 키 — siteDesign modulePolygonLayer 와 동일 */
export const MODULE_HIERARCHY_FEATURE_KEYS = {
  arraySeq: 'solar_array_seq',
  stringSeq: 'solar_string_seq',
  moduleSeq: 'solar_module_seq',
  arrayDisplayId: 'array_id',
  stringDisplayId: 'string_id',
  moduleDisplayId: 'module_id'
};

/** Drawer 트리 row kind */
export const MODULE_HIERARCHY_ROW_KIND = {
  ARRAY: 'array_header',
  STRING: 'string_header',
  MODULE: 'panel',
  MODULE_SINGLE: 'panel_single'
};

export function isModuleRowKind(kind) {
  return kind === MODULE_HIERARCHY_ROW_KIND.MODULE || kind === MODULE_HIERARCHY_ROW_KIND.MODULE_SINGLE;
}
